import { Select, Space, Tabs, Typography } from 'antd'
import { useState } from 'react'
import styled from 'styled-components'
import { DetailsPageLayout, Spacer, SubHeader } from '../../components'
import HeatMap from './Plotly/HeatMap'
import VolcanoPlot from './Plotly/VolcanoPlot'

const StyledPlaceHolder = styled.div`
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const { Title, Text } = Typography
const { TabPane } = Tabs

export const LibraryTypes = {
  plotly: 'plotly',
  d3: 'd3',
  chartjs: 'chartjs',
  recharts: 'recharts',
}

export type LibraryType = keyof typeof LibraryTypes

export const ChartTypes = {
  volcano: 'volcano',
  heatmap: 'heatmap',
  dotplot: 'dotplot',
}

export type ChartType = keyof typeof ChartTypes

const TestChartPage = () => {
  const [selectedLibrary, setSelectedLibrary] = useState(LibraryTypes.plotly)

  const chartLibraries = [
    {
      value: LibraryTypes.plotly,
      label: 'Plotly.js',
    },
    {
      value: LibraryTypes.d3,
      label: 'D3.js',
    },
    {
      value: LibraryTypes.chartjs,
      label: 'Chart.js',
    },
    {
      value: LibraryTypes.recharts,
      label: 'Recharts',
    },
  ]

  const renderChart = (chartType: ChartType) => {
    switch (chartType) {
      case ChartTypes.volcano:
        return selectedLibrary === LibraryTypes.plotly ? (
          <VolcanoPlot />
        ) : (
          <StyledPlaceHolder>
            <Text type="secondary">Volcano Plot...</Text>
          </StyledPlaceHolder>
        )
      case ChartTypes.heatmap:
        return <HeatMap />
      case ChartTypes.dotplot:
        return (
          <StyledPlaceHolder>
            <Text type="secondary">Dot Plot chart</Text>
          </StyledPlaceHolder>
        )
      default:
        return null
    }
  }

  return (
    <DetailsPageLayout>
      <SubHeader>
        <Title level={2} style={{ margin: 0 }}>
          Chart Library Investigation
        </Title>
        <Spacer />
        <Space>
          <Typography.Text strong>Charting Library:</Typography.Text>
          <Select
            value={selectedLibrary}
            onChange={setSelectedLibrary}
            options={chartLibraries}
            placeholder="Select a charting library"
            style={{ minWidth: 150 }}
          />
        </Space>
      </SubHeader>

      <Tabs
        defaultActiveKey="volcano"
        type="card"
        size="large"
        style={{ marginTop: 16 }}
      >
        <TabPane tab="Volcano Plot" key="volcano">
          {renderChart(ChartTypes.volcano as ChartType)}
        </TabPane>

        <TabPane tab="Heatmap" key="heatmap">
          {renderChart(ChartTypes.heatmap as ChartType)}
        </TabPane>

        <TabPane tab="Dot Plot" key="dotplot">
          {renderChart(ChartTypes.dotplot as ChartType)}
        </TabPane>
      </Tabs>
    </DetailsPageLayout>
  )
}

export default TestChartPage
